export default __webpack_public_path__ + "static/media/9.GRANDPARKHOTEL.cb149e66.jpg";